'use client';

import TriangleDialog from '@/components/icons/triangle-dialog';
import type { SelectionBubbleState, SelectionShareAction } from '../../types/lexical.types';

type SelectionShareBubbleProps = {
  bubbleRef: React.RefObject<HTMLDivElement | null>;
  selectionBubble: SelectionBubbleState;
  selectionActions: SelectionShareAction[];
};

export function SelectionShareBubble({
  bubbleRef,
  selectionBubble,
  selectionActions,
}: SelectionShareBubbleProps) {
  if (!selectionBubble.visible) return null;

  return (
    <div
      className="absolute z-20 pointer-events-auto"
      style={{
        left: selectionBubble.x,
        top: selectionBubble.y,
      }}
    >
      <div ref={bubbleRef} className="relative pt-3">
        <TriangleDialog
          className="absolute -top-1 w-4 h-4 rotate-90 text-white drop-shadow-[0px_5px_10px_rgba(209,213,223,0.35)]"
          style={{ left: selectionBubble.arrowOffset - 8 }}
        />
        <div className="flex items-center gap-1 bg-white rounded-full py-1 px-1.5 shadow-[0px_10px_20px_rgba(209,213,223,0.55)]">
          {selectionActions.map(({ id, color, Icon, title, onClick }) => (
            <button
              key={id}
              onMouseDown={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
              onTouchStart={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onClick();
              }}
              title={title}
              className="w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
              style={{ backgroundColor: color }}
            >
              <Icon className="w-4 h-4 text-white [&_path]:fill-white" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
